import {debug} from "util";

import {TextControlOptions} from "./TextControl.Options";
import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {DimensionStyleSet} from "InternalShared/PageBuilder/Controls/Properties/StyleSets/DimensionStyleSet";
import {GroupProperties} from "InternalShared/PageBuilder/Controls/Properties/styles/GroupProperties";
import {AllowedResizeDirection} from "InternalShared/Dto";
import {TextProperty} from "InternalShared/PageBuilder/Controls/Properties/TextProperty";
import {PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {SimpleTextProperty} from "InternalShared/PageBuilder/Controls/Properties/SimpleTextProperty";
import {LabelPositionEnum} from "PageBuilder/pagebuilder/Controls/ControlsList/FieldControl.Options";
import {DropDownProperty} from "InternalShared/PageBuilder/Controls/Properties/DropDownProperty";
import {CheckBoxProperty} from "InternalShared/PageBuilder/Controls/Properties/CheckBoxProperty";
import {PropertyBase} from "InternalShared/PageBuilder/Controls/Properties/PropertyBase";
import {NumberProperty} from "InternalShared/PageBuilder/Controls/Properties/NumberProperty";




declare let rednaoPDFInvoiceParams:any;
export class TextControl extends PDFControlBase{


    GetStyles(): GroupProperties[] {

            return [
                DimensionStyleSet.GetStyles(this),
                new GroupProperties('Paragraph').AddProperties([
                    new NumberProperty(this,'line-height',this.StyleManager.CreateStyleClassManager('p')).SetLabel('Line Height').SetPlaceholder('Default'),

                ])

            ];
    }
    public AllowedResizeDirection:AllowedResizeDirection="horizontal";
    public Options:TextControlOptions;
    private properties:GroupProperties[];



    public InternalInitialize() {
        this.StyleManager.AddStyleSet('p', {'padding': '0','margin':0});
    }


    public NeedTranslations(): boolean {
        return true;
    }

    public GetTranslatedText(): any {
        return {text:this.Options.Text};
    }

    protected InternalGenerateHtml($container: JQuery) {

        let text=document.createElement('p');
        text.innerHTML=this.Options.Text;

        let table=document.createElement('table');
        $container.append(table);
        let body=document.createElement('tbody');
        table.append(body);

        let textColumn=document.createElement('td');
        textColumn.className='TextValue';
        textColumn.append(text);

        let row;
        let column;
        if(this.Options.Label=='')
        {
            row=document.createElement('tr');
            body.append(row);
            row.append(textColumn);

        }else
        {


            let labelColumn=document.createElement('td');
            labelColumn.className='TextLabel';
            let label=document.createElement('p');
            label.innerText=this.Options.Label;
            labelColumn.append(label);


            switch (this.Options.LabelPosition) {
                case LabelPositionEnum.Top:
                    label.classList.add('Top');
                    row=document.createElement('tr');
                    body.append(row);
                    row.append(labelColumn);

                    row=document.createElement('tr');
                    body.append(row);
                    row.append(textColumn);


                    break;
                case LabelPositionEnum.Bottom:
                    label.classList.add('Bottom');
                    row=document.createElement('tr');
                    body.append(row);
                    row.append(textColumn);

                    row=document.createElement('tr');
                    body.append(row);
                    row.append(labelColumn);
                    break;
                case LabelPositionEnum.Lef:
                    label.classList.add('Left');
                    row=document.createElement('tr');
                    body.append(row);

                    row.append(labelColumn);
                    row.append(textColumn);
                    break;
                case LabelPositionEnum.Right:
                    label.classList.add('Right');
                    row=document.createElement('tr');
                    body.append(row);

                    row.append(textColumn);
                    row.append(labelColumn);
                    break;
            }



        }

        /*
        let text=jQuery('<p style="vertical-align: top;"></p>');
        text.append(this.Options.Text);
        $container.append(text);*/
    }

    public GetProperties(): GroupProperties[] {
        if(this.properties==null)
        {
            this.properties=[new GroupProperties('General')
                .AddProperties([
                    new SimpleTextProperty(this,'Label').Focus(),
                    new TextProperty(this,'Text').Focus().SetFields(this.Page.Form.Fields),
                    new DropDownProperty(this,'LabelPosition').SetLabel("Label Position").OnChange(e=>this.Refresh())
                        .AddOption('Top',LabelPositionEnum.Top.toString())
                        .AddOption('Bottom',LabelPositionEnum.Bottom.toString())
                        .AddOption('Left',LabelPositionEnum.Lef.toString())
                        .AddOption('Righ',LabelPositionEnum.Right.toString()),
                    (rednaoVar.IsDesignMode=='1'?new SimpleTextProperty(this,'TemplateFieldName').SetLabel('Template field name'):null),
                    (rednaoVar.IsDesignMode=='1'?new CheckBoxProperty(this,'HideFromTemplateDesigner').SetLabel('Hide from template designer'):null)
                ])];
        }

        return this.properties;
    }


    public AfterRefresh() {
        let height:number=this.$element.find('.elementContent').height();
        this.$element.velocity('stop',true);
        this.$element.velocity(200,"easeInExp");

    }

    GetInitialOptions(): Promise<PDFControlBaseOptions> {
        return new Promise(resolve => {
            resolve(new TextControlOptions().Merge());
        });
    }

    protected InternalGetLabel() {
        return this.Options.Label;
    }


    GetValueEditor():PropertyBase {
        return new TextProperty(this,'Text').SetLabel('')
    }
}
